/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { OrganizationMetadata, OrgMetaDataError } from '../../data/interfaces';
import {
    OrganizationMetadataActions,
    FETCH_ORGANIZATION_METADATA_FAILURE,
    FETCH_ORGANIZATION_METADATA_REQUEST,
    FETCH_ORGANIZATION_METADATA_SUCCESS,
} from '../types/organizationMetadata';

interface OrganizationMetadataState {
    organizationMetadata: OrganizationMetadata;
    error: OrgMetaDataError;
    loading: boolean;
    success: boolean;
}

const initialState: OrganizationMetadataState = {
    organizationMetadata: { uuid: '', handle: '' },
    error: {},
    loading: false,
    success: false,
};

const organizationMetadataReducer = (
    state = initialState,
    action: OrganizationMetadataActions
) => {
    switch (action.type) {
        case FETCH_ORGANIZATION_METADATA_REQUEST:
            return {
                ...state,
                loading: true,
                error: {},
                success: false,
            };
        case FETCH_ORGANIZATION_METADATA_SUCCESS: {
            const response = action.payload;
            return {
                ...state,
                loading: false,
                organizationMetadata: response,
                error: {},
                success: true,
            };
        }
        case FETCH_ORGANIZATION_METADATA_FAILURE:
            return {
                ...state,
                loading: false,
                organizationMetadata: { uuid: '', handle: '' },
                error: action.payload,
                success: false,
            };
        default:
            return state;
    }
};

export default organizationMetadataReducer;
